export default __webpack_public_path__ + "static/media/ssis.afb39799.png";